import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import Stack from '../../../../../atoms/Stack';
import Icon from '../../../../../atoms/Icon';
import ActionButton from '../../common/ActionButton';

import styles from './index.module.pcss';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

interface EventHeaderProps {
  platform: string;
  className?: string;
  middleImg?: string;
  headerBtnLabel?: string;
  EventHeaderText?: string;
  openDatePopupCB: () => {};
  openTnCDialog: () => {};
  onClick: () => void;
}

const cx = classNames.bind(styles);

function EventHeader(props: EventHeaderProps): JSX.Element {
  const {
    platform,
    className,
    middleImg,
    openDatePopupCB,
    headerBtnLabel,
    EventHeaderText,
    openTnCDialog,
    onClick
  } = props;

  const stackWidth = platform === 'app' ? [0, 80, 20] : [10, 65, 25];

  return (
    <>
      <div className={cx('EventHeaderContainer', className)}>
        <div className={cx('topHeader')}>
          <Stack widths={stackWidth} className={className}>
            {platform !== 'app' && (
              <Icon icon="icon-Back" iconClass={cx('backarrow')} onClick={onClick} />
            )}
            <div className={cx('lhs')}>
              <Text weight="bold" variant="T5" color="White">
                Events & Winners
              </Text>
            </div>
            <ActionButton
              btnLabel="T&C "
              variant="small"
              icon="icon-Chevron-Down"
              onClick={() => {
                openTnCDialog(true);
              }}
              btnTransParent
            />
          </Stack>
        </div>
        <div className={cx('middleCircle', 'middleCircleEvent')}>
          <img className={cx('middleImage')} alt="ballon" src={replaceWithJioCDN(middleImg)} />
        </div>
        <div className={cx('bottomHeader')} />
      </div>
      <Stack widths={[70, 30]} className={cx('headerText', className)}>
        <Text weight="bold" variant="T3">
          {EventHeaderText}
        </Text>
        <ActionButton
          btnLabel={headerBtnLabel}
          variant="small"
          icon="icon-Chevron-Down"
          onClick={() => openDatePopupCB(true)}
        />
      </Stack>
    </>
  );
}

EventHeader.defaultProps = {
  className: '',
  headerBtnLabel: '',
  EventHeaderText: '',
  middleImg: 'https://assets-jiocdn.ajio.com/static/img/Ajio-Logo.svg'
};

export default EventHeader;
